import { Trans, useTranslation } from 'react-i18next'
import { StyledLink } from 'components/Common/MasterComponents'
import {
  Paragraph,
  Header,
  EmptyInfo,
  Item,
  Content,
} from 'components/Pages/Wine/View/Main/Content/ColumnLeft/_styles'
import { useProduct } from 'components/Pages/Wine/View/Main/_methods'
import Collapsable from 'components/Pages/Wine/View/Common/Collapsable'
import useUserRole from 'utils/user/useUserRole'
import { useCapturedWine } from '../../_methods/context'

const Description = () => {
  const { t } = useTranslation()
  const product = useProduct()
  const { isAuthor, capturedWine, canEdit: canEditCtx } = useCapturedWine()
  const { isContent, isSuperAdmin } = useUserRole()

  const wine = product?.wine as any
  // ClusterWine имеет techSheets[], берём первый
  const techSheet = wine?.techSheets?.[0] ?? {}

  const viticulture = techSheet.viticulture ?? ''
  const vinification = techSheet.vinification ?? ''
  const wineAging = techSheet.wineAging ?? ''
  const vintageDetails = techSheet.vintageDetails ?? ''
  const tastingNote = techSheet.tastingNote ?? ''

  const isEmpty =
    !viticulture &&
    !vinification &&
    !wineAging &&
    !vintageDetails &&
    !tastingNote
  const canEdit =
    canEditCtx !== undefined
      ? canEditCtx
      : isContent || isSuperAdmin || isAuthor

  return (
    <Collapsable title={t('wine.view.description')}>
      <Content>
        {viticulture && (
          <Item>
            <Header>{t('wine.view.viticulture')}</Header>
            <Paragraph>{viticulture}</Paragraph>
          </Item>
        )}
        {vinification && (
          <Item>
            <Header>{t('wine.view.vinification')}</Header>
            <Paragraph>{vinification}</Paragraph>
          </Item>
        )}
        {wineAging && (
          <Item>
            <Header>{t('wine.view.wineAging')}</Header>
            <Paragraph>{wineAging}</Paragraph>
          </Item>
        )}
        {vintageDetails && (
          <Item>
            <Header>{t('wine.view.vintageDetails')}</Header>
            <Paragraph>{vintageDetails}</Paragraph>
          </Item>
        )}
        {tastingNote && (
          <Item>
            <Header>{t('wine.view.tastingNotes')}</Header>
            <Paragraph>{tastingNote}</Paragraph>
          </Item>
        )}
        {isEmpty && canEdit && (
          <EmptyInfo>
            <Trans
              t={t}
              i18nKey='wine.view.noDescription'
              components={[
                <StyledLink
                  key={0}
                  to={`/acc/captured-wine/${capturedWine.id}/edit/general`}
                />,
              ]}
            />
          </EmptyInfo>
        )}
        {isEmpty && !canEdit && (
          <EmptyInfo>{t('capturedWine.view.noDescription')}</EmptyInfo>
        )}
      </Content>
    </Collapsable>
  )
}

export default Description
